import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useState } from 'react';
import { FinanceDashboardCardChart } from '../cards/FinanceDashboardCardChart';
import { FinanceDashboardNetChart } from '../charts/FinanceDashboardNetChart';
import { FinanceDashboardPlChart } from '../charts/FinanceDashboardPlChart';
import { FinanceDashboardSankeyChart } from '../charts/FinanceDashboardSankeyChart';
import { FinanceDashboardWaterfallChart } from '../charts/FinanceDashboardWaterfallChart';


export const DemFinanceDashboardPlView = ({ startPeriod, endPeriod, periodicity, prodIds, channelIds, periods }) => {

  const [hoverCategory, setHoverCategory] = useState(null);


  return (
    <SpacerLayout>
      <Spacer>
        <Spacer weights={[5, 1]} vertical>
          <DashboardCard title="Gross-To-Net">
            <FinanceDashboardPlChart entity="SBC" chartType="STACK" startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} channelIds={channelIds} onHoverCategoryChange={setHoverCategory} periods={periods} />
          </DashboardCard>
          <Spacer>
            <FinanceDashboardCardChart entity="SBC" direction="Increase" changeType="percent" startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} channelIds={channelIds} />
            <FinanceDashboardCardChart entity="SBC" direction="Decrease" changeType="percent" startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} channelIds={channelIds} />
          </Spacer>
        </Spacer>
        {hoverCategory ? (
          <Spacer vertical>
            <DashboardCard title={`Sankey ${hoverCategory}`}>
              <FinanceDashboardSankeyChart
                entity="SBC"
                startPeriod={startPeriod}
                endPeriod={endPeriod}
                periodicity={periodicity}
                prodIds={prodIds}
                channelIds={channelIds}
                hoveredCategory={hoverCategory}
              />
            </DashboardCard>

            <DashboardCard title={`Waterfall ${hoverCategory}`}>
              <FinanceDashboardWaterfallChart
                entity="SBC"
                startPeriod={startPeriod}
                endPeriod={endPeriod}
                periodicity={periodicity}
                prodIds={prodIds}
                channelIds={channelIds}
                hoveredCategory={hoverCategory}
              />
            </DashboardCard>
          </Spacer>
        ) : (
          <DashboardCard title={`Net Sales YoY % Growth`}>
            <FinanceDashboardNetChart
              entity="SBC"
              startPeriod={startPeriod}
              endPeriod={endPeriod}
              periodicity={periodicity}
              prodIds={prodIds}
              channelIds={channelIds}
            />
          </DashboardCard>
        )}
      </Spacer>

    </SpacerLayout>
  )
}